import React, { useState } from 'react';

import { Button, createStyles, Group, Text, Title, useMantineTheme } from '@mantine/core';
import { useDebouncedValue, useDisclosure } from '@mantine/hooks';
import { IconChevronDown, IconPlus } from '@tabler/icons-react';
import AthletePackageCreateForm from 'pages/private/owner/AthleteDetail/components/Packages/components/AthletePackageCreateForm';
import { AthletePackageSearchFilters } from 'pages/private/owner/AthleteDetail/components/Packages/types';
import { AthleteRetrieve } from 'types';

import AthletePackagesTable from './components/AthletePackagesTable';
import FiltersDrawer from './components/FiltersDrawer';

const useStyles = createStyles(theme => ({
  header: {
    display: 'grid',
    gridTemplateColumns: '3fr 1fr 1fr',
    paddingBottom: theme.spacing.sm,
  },
  tabText: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginLeft: theme.spacing.lg,
  },
}));

const Packages = ({
  openTabsDrawer,
  athlete,
  permission = true,
}: {
  openTabsDrawer: () => void;
  athlete: AthleteRetrieve;
  permission?: boolean;
}): JSX.Element => {
  const theme = useMantineTheme();
  const { classes } = useStyles();
  const [isFiltersOpen, { open: openFilters, close: closeFilters }] = useDisclosure(false);
  const [isCreateFormOpened, { open, close }] = useDisclosure(false);
  const initialSearchFilters: AthletePackageSearchFilters = {
    statuses: ['ACTIVE', 'UPCOMING', 'HOLD'],
  };
  const [searchFilters, setSearchFilters] = useState<AthletePackageSearchFilters>(initialSearchFilters);
  const [debouncedSearchFilters] = useDebouncedValue<AthletePackageSearchFilters>(searchFilters, 250);

  return (
    <>
      <Group className={classes.header}>
        <Text size='md' fw='bold' className={classes.tabText} onClick={openTabsDrawer}>
          Packages
          <IconChevronDown size={16} style={{ marginLeft: 4 }} />
        </Text>
        <Button onClick={openFilters} size='xs' disabled={!permission}>
          Filters
        </Button>
        <Button
          leftIcon={<IconPlus size={theme.fontSizes.md} />}
          onClick={open}
          size='xs'
          disabled={!permission}
        >
          Package
        </Button>
      </Group>
      <AthletePackagesTable
        athlete={athlete}
        permission={permission}
        searchFilters={debouncedSearchFilters}
      />
      <AthletePackageCreateForm
        athleteId={athlete.athleteId}
        title={<Title order={3}>Add Package</Title>}
        opened={isCreateFormOpened}
        closeHandler={close}
      />
      <FiltersDrawer
        opened={isFiltersOpen}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        closeFilters={closeFilters}
      />
    </>
  );
};

export default Packages;
